import { render, staticRenderFns } from "./verticalButton.vue?vue&type=template&id=7b0869ad"
import script from "./verticalButton.vue?vue&type=script&lang=js"
export * from "./verticalButton.vue?vue&type=script&lang=js"
import style0 from "./verticalButton.vue?vue&type=style&index=0&id=7b0869ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports